import { toast } from 'react-toastify'
import * as actionTypes from './actionTypes'
import campaniaService from '../../api/campaniaService'

export const setCampanias = (campanias) => {
  return { type: actionTypes.LOAD_CAMPANIAS, payload: { campanias } }
}

const setLoadingCampanias = (loading) => {
  return { type: actionTypes.LOADING_CAMPANIAS, payload: { loading } }
}

const setLoadingNotificacionSectorista = (loading) => {
  return { type: actionTypes.LOADING_NOTIFICACION_SECTORISTA, payload: { loading } }
}

export const getCampanias = () => async (dispatch) => {
  dispatch(setLoadingCampanias(true))
  try {
    const response = await campaniaService.listCampanias();
    dispatch(setCampanias(response.data.campanias))
    dispatch(setLoadingCampanias(false))
  } catch (error) {
    dispatch(setLoadingCampanias(false))
    toast.error(error)
  }
}


export const sendNotificacionSectorista = (request) => async (dispatch) => {
  dispatch(setLoadingNotificacionSectorista(true))
  try {
    const response = await campaniaService.notificarSectorista(request);
    dispatch(setLoadingNotificacionSectorista(false))
    return response;
  } catch (error) {
    dispatch(setLoadingNotificacionSectorista(false))
    throw error
  }
}

